import { render, staticRenderFns } from "./PayrollInfoEmployerPaidDealsGrid.vue?vue&type=template&id=39e8fda5&"
import script from "./PayrollInfoEmployerPaidDealsGrid.vue?vue&type=script&lang=js&"
export * from "./PayrollInfoEmployerPaidDealsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports